import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LayoutComponent} from "./layout/portal-layout/layout.component";
import {LayoutBlankComponent} from "./layout/blank-layout/layout_blank.component";
import { TranslatorService } from './core/translator/translator.service';
import { MenuService } from './core/menu/menu.service';
import { SharedModule } from './shared/shared.module';
import { PagesModule } from './routes/pages/pages.module';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'admin', pathMatch: 'full' },
      { path: 'admin',
        loadChildren: () => import('./routes/pages/portal-sections/portal-sections.module').then(m => m.PortalSectionsModule)
        //loadChildren: './pages/portal-sections/portal-sections.module#PortalSectionsModule'
      },
    ]
  },
  {
    path: '',
    component: LayoutBlankComponent,
    children: [
      { path: 'login', loadChildren: () => import('./routes/pages/authentication-sections/login/login.module').then(m => m.LoginModule)
        //loadChildren: './pages/authentication-sections/login/login.module#LoginModule'
      },
      { path: 'login/:id',
        loadChildren: () => import('./routes/pages/authentication-sections/login/login.module').then(m => m.LoginModule)
        //loadChildren: './pages/authentication-sections/login/login.module#LoginModule'
      },
      { path: 'company', loadChildren: () => import('./routes/pages/authentication-sections/company/company.module').then(m => m.CompanyModule) },
      { path: 'register', loadChildren: () => import('./routes/pages/authentication-sections/register/register.module').then(m => m.RegisterModule) },
      { path: 'recover', loadChildren: () => import('./routes/pages/authentication-sections/recover/recover.module').then(m => m.RecoverModule) },
      { path: 'activate/:id', loadChildren: ()=> import('./routes/pages/authentication-sections/activate/activate.module').then(m => m.ActivateModule) },
    ]
  },

  { path: '**', redirectTo: '404' }


  /*
    {
      path: '',
      component: LayoutComponent,
      children: [
        { path: '', redirectTo: 'admin', pathMatch: 'full' },
        { path: 'admin',
          loadChildren: () => import('./pages/portal-sections/portal-sections.module').then(m => m.PortalSectionsModule)
          //loadChildren: './pages/portal-sections/portal-sections.module#PortalSectionsModule'
        },
      ]
    },
  */
/*

  {
    path: '',
    component: LayoutBlankComponent,
    children: [ ]
  },

  {
    path: '',
    component: LayoutBlankComponent,
    children: [
      { path: 'login', loadChildren: () => import('./routes/pages/authentication-sections/login/login.module').then(m => m.LoginModule)
        //loadChildren: './pages/authentication-sections/login/login.module#LoginModule'
      },
      { path: 'login/:id',
        loadChildren: () => import('./routes/pages/authentication-sections/login/login.module').then(m => m.LoginModule)
        //loadChildren: './pages/authentication-sections/login/login.module#LoginModule'
      }
    ]
  },

  { path: '**', redirectTo: '404' }
*/

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    PagesModule,
    SharedModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(public menuService: MenuService, tr: TranslatorService) {
  }
}
